import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap/dist/js/bootstrap.js';
import React, { Suspense } from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from "react-redux";
import { BrowserRouter } from 'react-router-dom';
import { App } from './App';
import { store } from './Redux/store';
import './index.css';
import reportWebVitals from './reportWebVitals';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import Loader from './components/Layout/Loader';
import { getActiveProject } from './components/CommonComponents/ProjectConfig';
import { initTranslationObserver } from './components/CommonComponents/TranslationObserver';
import { GoogleOAuthProvider } from '@react-oauth/google';

initTranslationObserver();
const baseUrl = document.getElementsByTagName('base')[0].getAttribute('href');
const rootElement = document.getElementById('root');
const root = createRoot(rootElement);

const activeProject = getActiveProject();
const YOUR_GOOGLE_CLIENT_ID = activeProject.googleClientID;

if (process.env.REACT_APP_DISABLE_CONSOLE === "true") {
    (function () {
        const noop = () => { };
        console.log = noop;
        console.warn = noop;
        console.error = noop;
        console.info = noop;
        console.debug = noop;
        console.trace = noop;
        window.console.log = noop;
        window.console.warn = noop;
        window.console.error = noop;
        window.console.info = noop;
        window.console.debug = noop;
        window.console.trace = noop;
    })();
}

root.render(
    <BrowserRouter basename={baseUrl}>
        <Provider store={store}>
            <GoogleOAuthProvider clientId={YOUR_GOOGLE_CLIENT_ID}>
            <Suspense fallback={<Loader />}>
                <App />
                </Suspense>
            </GoogleOAuthProvider>
        </Provider >
    </BrowserRouter>
);
serviceWorkerRegistration.unregister();
reportWebVitals();